import axios from "axios";

const instacartApiKey = process.env.REACT_APP_INSTACART_API_KEY

export const instacartApi = axios.create({
    // baseURL: "https://connect.dev.instacart.tools/idp/v1/products/",
    baseURL: "https://connect.instacart.com/idp/v1/products/",
    headers: {Authorization: `Bearer ${instacartApiKey}`}
})